// extracted by mini-css-extract-plugin
module.exports = {"card":"CH","selected":"DH","addressLabel":"EH","radio":"FH","disabled":"GH"};